export default "__VITE_ASSET__BcjgHYk0__"